import { useEffect, useState } from "react";
import { t } from "../lib/sprache";
import { merkeSchritt } from "../lib/melden";
import { MeldenKnopf } from "./Melden";

/** Meldungen unten rechts (.toast aus dem Design), mindestens 5 Sekunden sichtbar; Fehler bleiben bis zum Schließen. */
type Toast = { id: number; text: string; kind: "status" | "alert"; anlass?: string; ohneMelden?: boolean };
let seq = 0;
const listeners = new Set<(t: Toast[]) => void>();
let items: Toast[] = [];

function emit() {
  for (const l of listeners) l(items);
}
/**
 * `anlass` (P-1, 21.10.2026): Kennung der Aktion, zu der eine Fehlermeldung gehört. Gelingt dieselbe Aktion später, verschwinden
 * ihre älteren Fehlermeldungen (dismissAnlass); eine neue Fehlermeldung derselben Aktion ersetzt die alte.
 */
/** `melden: false`: fachlicher Hinweis, der bis zum Schließen bleibt, aber kein Fehler bei uns ist (z. B. Ergebnis der VIES-Prüfung) */
export function toast(text: string, kind: "status" | "alert" = "status", anlass?: string, opts?: { melden?: boolean }) {
  if (anlass) items = items.filter((x) => x.anlass !== anlass);
  const t: Toast = { id: ++seq, text, kind, ...(anlass ? { anlass } : {}), ...(opts?.melden === false ? { ohneMelden: true } : {}) };
  merkeSchritt("meldung", text);
  items = [...items, t];
  emit();
  if (kind === "status") setTimeout(() => dismiss(t.id), 5000);
}
/** Alle Meldungen einer Aktion schließen (nach einem erfolgreichen Versuch derselben Aktion) */
export function dismissAnlass(anlass: string) {
  if (!items.some((x) => x.anlass === anlass)) return;
  items = items.filter((x) => x.anlass !== anlass);
  emit();
}
/** Offene Meldungen (für Tests) */
export function offeneMeldungen(): readonly { text: string; kind: "status" | "alert"; anlass?: string; ohneMelden?: boolean }[] {
  return items;
}
function dismiss(id: number) {
  items = items.filter((x) => x.id !== id);
  emit();
}

export function Toasts() {
  const [list, setList] = useState<Toast[]>(items);
  useEffect(() => {
    listeners.add(setList);
    return () => {
      listeners.delete(setList);
    };
  }, []);
  return (
    <>
      {list.map((m, i) => (
        <div key={m.id} className="toast" role={m.kind} style={i ? { bottom: `calc(var(--space-6) + ${i * 64}px)` } : undefined}>
          {m.text}
          {m.kind === "alert" && !m.ohneMelden && <MeldenKnopf message={m.text} className="quiet tk-toast-close" />}
          {m.kind === "alert" && (
            <button className="quiet tk-toast-close" onClick={() => dismiss(m.id)} aria-label={t("Meldung schließen", "Close message")}>
              {t("Schließen", "Close")}</button>
          )}
        </div>
      ))}
    </>
  );
}
